import { getUserInfo } from '../server/api';

export const USER_INFO_STORAGE_KEY = 'userInfo';
export const USER_INFO_UPDATED_EVENT = 'user-info-updated';

let inflightRefreshPromise = null;
let lastRefreshAt = 0;

export const readUserInfo = () => {
  try {
    const raw = sessionStorage.getItem(USER_INFO_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};

export const readToken = () => {
  try {
    return sessionStorage.getItem('token') || '';
  } catch (_) {
    return '';
  }
};

export const emitUserInfoUpdated = () => {
  window.dispatchEvent(new Event(USER_INFO_UPDATED_EVENT));
};

export const writeUserInfo = (userInfo) => {
  if (userInfo) {
    sessionStorage.setItem(USER_INFO_STORAGE_KEY, JSON.stringify(userInfo));
  } else {
    sessionStorage.removeItem(USER_INFO_STORAGE_KEY);
  }
  emitUserInfoUpdated();
};

export const clearUserInfoStorage = () => {
  sessionStorage.removeItem(USER_INFO_STORAGE_KEY);
  emitUserInfoUpdated();
};

export const normalizeUserInfo = (resultData, previousUserInfo = null) => {
  const nextUserInfo = {
    ...resultData,
    state: resultData?.state,
    token: resultData?.token,
    roleCode: resultData?.roleCode,
    userType: resultData?.userType,
    userName: resultData?.pubUserName,
    id: resultData?.userId,
    avatar: resultData?.avatar,
  };

  if (Number(resultData?.userType) === 2 || resultData?.roleCode === 'company') {
    const orgInfo = resultData?.checkOrgInfo || {};
    return {
      ...nextUserInfo,
      state: orgInfo?.state ?? resultData?.state ?? previousUserInfo?.state ?? null,
      phoneNo: orgInfo?.contactTel || previousUserInfo?.phoneNo || '',
      lastLoginTime: orgInfo?.lastLoginTime || previousUserInfo?.lastLoginTime || '',
      email: orgInfo?.orgEmail || previousUserInfo?.email || '',
      orgProfile: orgInfo,
      registerLogList: resultData?.registerLogList || [],
    };
  }

  const personalInfo = resultData?.pubUserInfo || {};
  return {
    ...nextUserInfo,
    phoneNo: personalInfo?.phoneNo || previousUserInfo?.phoneNo || '',
    lastLoginTime: personalInfo?.lastLoginTime || previousUserInfo?.lastLoginTime || '',
    email: previousUserInfo?.email || '',
    registerLogList: resultData?.registerLogList || [],
  };
};

export const refreshUserInfoCache = async ({ force = false } = {}) => {
  const token = readToken();
  const currentUserInfo = readUserInfo();

  if (!token) {
    clearUserInfoStorage();
    return null;
  }

  const now = Date.now();
  if (!force && inflightRefreshPromise) {
    return inflightRefreshPromise;
  }

  if (!force && now - lastRefreshAt < 3000) {
    return currentUserInfo;
  }

  inflightRefreshPromise = (async () => {
    try {
      const response = await getUserInfo();
      const resultData = response?.data?.result;

      if (response?.status === 200 && resultData) {
        const nextUserInfo = normalizeUserInfo(resultData, currentUserInfo);
        writeUserInfo(nextUserInfo);
        lastRefreshAt = Date.now();
        return nextUserInfo;
      }
    } catch (_) {
      // Ignore refresh failures and keep cached data.
    }

    lastRefreshAt = Date.now();
    return currentUserInfo;
  })();

  try {
    return await inflightRefreshPromise;
  } finally {
    inflightRefreshPromise = null;
  }
};
